import {InputContextValue} from 'components/common/CartItemBuilder/providers/InputProvider/types'
import {useCallback} from 'react'
import {useUserInputStepManager} from './useUserInputStepManager'

export const useDateManager = (cartItemInputContextValue: InputContextValue) => {
  const getSavedData = useCallback(() => {
    return cartItemInputContextValue.input.date
  }, [cartItemInputContextValue])

  const setSavedData = useCallback(
    (date: string) => {
      cartItemInputContextValue.mutators.setDate(date)
    },
    [cartItemInputContextValue]
  )

  const isDataTouched = useCallback((date: string) => {
    return Boolean(date)
  }, [])

  const isDataValid = useCallback((date: string) => {
    return Boolean(date)
  }, [])

  return useUserInputStepManager<string>({
    getSavedData,
    setSavedData,
    isDataTouched,
    isDataValid,
    hint: 'Please select a tour date',
  })
}
